import plan from "../images/plan/plan.jpg"
import overview from "../images/plan/overview.jpg"

import marker from "../images/icon/marker.png"
import pieRange from "../images/icon/pieRange.png"

import GeneralMachiningCh from "../images/plan/button/零件加工.png"
import AerospaceCh from "../images/plan/button/航太產業加工.png"
import MicromachiningCh from "../images/plan/button/微細加工.png"
import AutomotiveCh from "../images/plan/button/汽機車產業加工.png"
import DieMoldCh from "../images/plan/button/模具加工.png"
import CorporateSituationRoomCh from "../images/plan/button/戰情室.png"
import SmartManufacturingCh from "../images/plan/button/智慧智造解決方案.png"
import SmartAutomationCh from "../images/plan/button/智慧自動化.png"

import GeneralMachiningEn from "../images/plan/button/GeneralMachining.png"
import AerospaceEn from "../images/plan/button/Aerospace.png"
import MicromachiningEn from "../images/plan/button/Micromachining.png"
import AutomotiveEn from "../images/plan/button/Automotive.png"
import DieMoldEn from "../images/plan/button/Die_Mold.png"
import CorporateSituationRoomEn from "../images/plan/button/CorporateSituationRoom.png"
import SmartManufacturingEn from "../images/plan/button/SmartManufacturingSolutions.png"
import SmartAutomationEn from "../images/plan/button/SmartAutomation.png"

const markerPath1Config = [
    //args:[gotoscene,goToYaw, goToPitch]
    {top:'46%', left:'86%',adjustAngle:90, args:[0,0,0]},   //scene1
    {top:'46%', left:'81%',adjustAngle:90, args:[1,45,0]},  //scene2
    {top:'46%', left:'73%',adjustAngle:90, args:[2,45,0]},  //scene3
    {top:'46%', left:'68%',adjustAngle:90, args:[3,-135,0]},//scene4
    {top:'46%', left:'64%',adjustAngle:90, args:[4,135,0]}, //scene5
    {top:'46%', left:'60%',adjustAngle:90, args:[5,45,0]},  //scene6
    {top:'46%', left:'55%',adjustAngle:90, args:[6,-45,0]}, //scene7
    {top:'46%', left:'50%',adjustAngle:90, args:[7,45,0]},  //scene8
    {top:'46%', left:'44%',adjustAngle:90, args:[8,45,0]},  //scene9
    {top:'46%', left:'41%',adjustAngle:90, args:[9,-135,0]},//scene10
    {top:'46%', left:'37%',adjustAngle:90, args:[10,30,0]}, //scene11
    {top:'46%', left:'29%',adjustAngle:90, args:[11,-45,0]},//scene12
    {top:'46%', left:'25%',adjustAngle:90, args:[12,0,0]},  //scene13
    {top:'53%', left:'22%',adjustAngle:90, args:[13,0,0]},  //scene14
    {top:'43%', left:'17%',adjustAngle:90, args:[14,0,0]},  //scene15
    {top:'40%', left:'23%',adjustAngle:-45,args:[15,0,-30]},//scene16
    {top:'32%', left:'22%',adjustAngle:-90,args:[16,0,-30]},//scene17
    {top:'40%', left:'35%',adjustAngle:45, args:[17,0,-30]},//scene18
    {top:'32%', left:'36%',adjustAngle:90, args:[18,0,-30]},//scene19
    {top:'64%', left:'78%',adjustAngle:90, args:[19,44.5,-12]},  //scene20
    {top:'29%', left:'78%',adjustAngle:90, args:[20,-44.5,-12]},  //scene21
    {top:'29%', left:'49%',adjustAngle:90, args:[21,-44.5,-12]},  //scene22
    {top:'64%', left:'54%',adjustAngle:90, args:[22,44.5,-12]},  //scene23
    {top:'64%', left:'33%',adjustAngle:90, args:[23,44.5,-12]},  //scene24
]

const mapBtnPath1Config=[
    //args:[gotoscene,goToYaw, goToPitch]
    { planTop:'20%', planLeft:'63%',overviewTop:'30%', overviewLeft:'50%', imgCh:GeneralMachiningCh, imgEn:GeneralMachiningEn, args:[1,45,0] },
    { planTop:'75%', planLeft:'66%',overviewTop:'63%', overviewLeft:'24%', imgCh:AerospaceCh, imgEn:AerospaceEn, args:[1,-45,0]},
    { planTop:'20%', planLeft:'40%',overviewTop:'21%', overviewLeft:'34%', imgCh:MicromachiningCh,imgEn:MicromachiningEn,args:[7,60,0]},
    { planTop:'75%', planLeft:'45%',overviewTop:'39%', overviewLeft:'12%', imgCh:AutomotiveCh,imgEn:AutomotiveEn,args:[6,-60,0]},
    { planTop:'75%', planLeft:'25%',overviewTop:'25%', overviewLeft:'4%', imgCh:DieMoldCh,imgEn:DieMoldEn,args:[10,-45,0]},
    { planTop:'38%', planLeft:'12%',overviewTop:'6%', overviewLeft:'19%', imgCh:CorporateSituationRoomCh,imgEn:CorporateSituationRoomEn,args:[12,10,0]},
    { planTop:'52%', planLeft:'7%',overviewTop:'10%', overviewLeft:'4%', imgCh:SmartManufacturingCh,imgEn:SmartManufacturingEn,args:[13,0,0]},
    { planTop:'20%', planLeft:'25%',overviewTop:'14%', overviewLeft:'26%', imgCh:SmartAutomationCh,imgEn:SmartAutomationEn,args:[17,0,-30]},
]

const markerPath2Config = [
    //args:[gotoscene,goToYaw, goToPitch]
    {top:'46%', left:'87%',adjustAngle:90, args:[0,0,0]},   //scene1
    {top:'46%', left:'73%',adjustAngle:90, args:[1,0,0]},   //scene2
    {top:'46%', left:'60%',adjustAngle:90, args:[2,0,0]},   //scene3
    {top:'46%', left:'45%',adjustAngle:90, args:[3,0,0]},   //scene4
    {top:'46%', left:'30%',adjustAngle:90, args:[4,0,0]},   //scene5
    {top:'54%', left:'22%',adjustAngle:90, args:[5,0,0]},   //scene6
    {top:'42%', left:'17%',adjustAngle:90, args:[6,0,0]},   //scene7
    {top:'42%', left:'71%',adjustAngle:0, args:[7,0,0]},   //scene8
    {top:'42%', left:'66.5%',adjustAngle:0, args:[8,0,0]},   //scene9
    {top:'42%', left:'62%',adjustAngle:0, args:[9,0,7]},   //scene10
    {top:'42%', left:'57%',adjustAngle:0, args:[10,0,0]},   //scene11
    {top:'42%', left:'42.5%',adjustAngle:0, args:[11,0,0]},   //scene12
    {top:'42%', left:'39.5%',adjustAngle:0, args:[12,0,0]},   //scene13
    {top:'53%', left:'71%',adjustAngle:160, args:[13,0,0]},   //scene14
    {top:'53%', left:'65%',adjustAngle:160, args:[14,0,0]},   //scene15
    {top:'53%', left:'48%',adjustAngle:160, args:[15,0,0]},   //scene16
    {top:'53%', left:'43.5%',adjustAngle:180, args:[16,0,0]},   //scene17
    {top:'53%', left:'26%',adjustAngle:160, args:[17,0,0]},   //scene18
    {top:'41%', left:'30%',adjustAngle:10, args:[18,0,0]},   //scene19
    {top:'41%', left:'23%',adjustAngle:-45, args:[19,0,-30]},   //scene20
    {top:'34%', left:'22%',adjustAngle:-90, args:[20,0,-30]},   //scene21
    {top:'41%', left:'35.5%',adjustAngle:45, args:[21,0,-30]},   //scene22
    {top:'34%', left:'36.5%',adjustAngle:90, args:[22,0,-30]},   //scene23
    {top:'29%', left:'78%',adjustAngle:90, args:[23,-44.5,-12]},   //scene24
    {top:'29%', left:'48%',adjustAngle:90, args:[24,-44.5,-12]},   //scene25
    {top:'66%', left:'78%',adjustAngle:90, args:[25,44.5,-12]},   //scene26
    {top:'66%', left:'54%',adjustAngle:90, args:[26,44.5,-12]},   //scene27
    {top:'66%', left:'33%',adjustAngle:90, args:[27,44.5,-12]},   //scene28
]

const mapBtnPath2Config = [
    //args:[gotoscene,goToYaw, goToPitch]
    { planTop:'20%', planLeft:'63%',overviewTop:'30%', overviewLeft:'50%', imgCh:GeneralMachiningCh, imgEn:GeneralMachiningEn, args:[1,117,0] },
    { planTop:'75%', planLeft:'66%',overviewTop:'63%', overviewLeft:'24%', imgCh:AerospaceCh, imgEn:AerospaceEn, args:[1,-127,0]},
    { planTop:'20%', planLeft:'40%',overviewTop:'21%', overviewLeft:'34%', imgCh:MicromachiningCh,imgEn:MicromachiningEn,args:[3,115,0]},
    { planTop:'75%', planLeft:'45%',overviewTop:'39%', overviewLeft:'12%', imgCh:AutomotiveCh,imgEn:AutomotiveEn,args:[2,-50,0]},
    { planTop:'75%', planLeft:'25%',overviewTop:'25%', overviewLeft:'4%', imgCh:DieMoldCh,imgEn:DieMoldEn,args:[4,-128,0]},
    { planTop:'38%', planLeft:'12%',overviewTop:'6%', overviewLeft:'19%', imgCh:CorporateSituationRoomCh,imgEn:CorporateSituationRoomEn,args:[6,0,0]},
    { planTop:'52%', planLeft:'7%',overviewTop:'10%', overviewLeft:'4%', imgCh:SmartManufacturingCh,imgEn:SmartManufacturingEn,args:[5,0,0]},
    { planTop:'20%', planLeft:'25%',overviewTop:'14%', overviewLeft:'26%', imgCh:SmartAutomationCh,imgEn:SmartAutomationEn,args:[18,0,0]},
]

export {overview, 
        plan,
        marker,
        pieRange,
        markerPath1Config,
        mapBtnPath1Config,
        markerPath2Config,
        mapBtnPath2Config,
    }